export const REACT_ROUTES = {
    HOME: '/',
    SIGN_UP: '/sign-up',
    SCHEDULER: '/scheduler',
    CUSTOMERS: '/customers',
    CUSTOMER: '/customer',
    WORKERS: '/workers',
    WORKER: '/worker',
    PLACES: '/places',
    PLACE: '/place',
    ARTICLE: '/article',
    PERCENTAGE: '/percentage',
    ARTICLES: '/articles',
    ARTICLE_TABS: '/article-tabs',
    DIGITAL_RECORD: '/digital-record',
    SETTINGS: '/settings',
    ADD_USER: '/add-user',
    ADD_USER_PASSWORD: '/add-user-password',
    AREAS: '/areas',
    AREA: '/area',
    SUB_AREAS: '/sub-areas',
    SUB_AREA: '/sub-area',
    THERAPIES: '/therapies',
    THERAPY: '/therapy',
    REPORT_TABS: '/reports-tabs',
    EXPENSE_TABS: '/expense-tabs',
    EXPENSE: '/expense',
    EXPENSE_TYPE: '/expense-type',
    MLP: '/mlp',
    MLPS: '/mlps',
    PROTOCOLS: '/protocols' ,
    // ! Keep it last
    ERROR_PAGE: '/error'
}
